import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { isDesktop } from '../../../helpers/browser';
export default function ImageBackground(props) {
    const canvasRef = useRef(null);
    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            // @ts-ignore
            const ctx = canvas.getContext('2d', {
                willReadFrequently: true
            });
            const image = new Image();
            // enabling this throws a CORS error and shows no image
            // disabling it doesn't throw a CORS error, but we can't get the pixeldata instead:
            // Uncaught SecurityError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The canvas has been tainted by cross-origin data.
            // To not waste any time in Cors hell, I disabled in Yii the cors header in CorsHeader.php, and 
            // set it in .htaccess: Header add Access-Control-Allow-Origin "*"
            // This way I could at least get this background color and box resizing to work
            image.crossOrigin = 'Anonymous';
            image.src = props.imageUrl;
            image.onload = () => {
                // Draw the image onto the canvas
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0);
                // Get the pixel data of the top-left corner (position: 0,0)
                const pixelData = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, 1, 1).data;
                // Extract RGB values from the pixel data
                // @ts-ignore
                const [red, green, blue] = pixelData;
                // Convert RGB values to hex code
                const hexCode = rgbToHex(red, green, blue);
                // console.log('Background color:', hexCode)
                let container = canvas.closest('div');
                if (container) {
                    // @ts-ignore
                    container.style.backgroundColor = hexCode;
                    container.innerHTML = '';
                    let img = document.createElement('img');
                    img.src = props.imageUrl;
                    img.title = props.name;
                    if (!props.noPositioning) {
                        let maxHeight = image.width * 1.5;
                        img.style.position = 'absolute';
                        img.style.top = '50%';
                        img.style.left = '50%';
                        img.style.transform = 'translate(-50%, -50%)';
                        img.style.height = `${Math.min(maxHeight, image.height)}px`;
                        container.appendChild(img);
                    }
                    else if (props.pageHeader) {
                        if (isDesktop) {
                            img.style.maxWidth = '350px';
                            img.style.borderRight = '#efefef 1px solid';
                            img.style.objectFit = 'contain';
                            img.style.alignSelf = 'flex-start';
                            img.style.display = 'flex';
                            container.appendChild(img);
                        }
                        else {
                            img.style.maxHeight = '250px';
                            img.style.margin = '0 auto';
                            img.style.width = 'fit-content';
                            img.style.display = 'block';
                            let imgContainer = document.createElement('div');
                            imgContainer.appendChild(img);
                            container.appendChild(imgContainer);
                        }
                    }
                    else {
                        if (isDesktop) {
                            img.style.position = 'absolute';
                            img.style.width = '150px';
                            img.style.top = '50%';
                            img.style.height = 'fit-content';
                            img.style.transform = 'translate(0, -50%)';
                            container.appendChild(img);
                        }
                        else {
                            // img.style.height = '100%'
                            // img.style.maxWidth = '150px'
                            img.style.maxHeight = '6em';
                            img.style.margin = '0 auto';
                            // img.style.display = 'block'
                            img.style.maxWidth = '100px';
                            let imgContainer = document.createElement('div');
                            imgContainer.style.margin = '0 auto';
                            imgContainer.style.position = 'relative';
                            imgContainer.style.alignContent = 'center';
                            imgContainer.appendChild(img);
                            container.appendChild(imgContainer);
                        }
                    }
                }
            };
        }
    }, [props.imageUrl]);
    // Helper function to convert RGB values to hex code
    const rgbToHex = (r, g, b) => `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
    return _jsx("canvas", { ref: canvasRef, style: { display: 'none' } });
}
